import { useTranslations } from '~/services/umbraco/hooks';
import useUserProfile from '~/services/shop/hooks/mit-fog/useUserProfile';
import { Text } from '~/shared/components/Text';
import { ModuleContainer } from '../../shared/ModuleContainer';
import AccountInformation from './components/AccountInformation/AccountInformation';
import UserProfileSkeleton from './components/Skeleton';
import UserInformation from './components/UserInformation/UserInformation';
import { Section } from './styled';


export default function M205UserProfile() {
  const { isLoading } = useUserProfile()
  const { translate } = useTranslations();

  if (isLoading) return (<UserProfileSkeleton />)

  return (
    <ModuleContainer spacingTop='none'>
      <Section>
        <Text as="h1" variant="display2" >
          {translate('mit-fog.userProfile.myProfile')}
        </Text>

        <Text as="h2" variant="display5">
          {translate('mit-fog.userProfile.userInformation')}
        </Text>

        <UserInformation />

        <Text as="h2" variant="display5">
          {translate('mit-fog.userProfile.accountInformation')}
        </Text>

        <AccountInformation />

      </Section>
    </ModuleContainer>
  );
}
